<div class="page-wrapper" *ngIf="page">
  <main>
    <section class="legal-hero" aria-labelledby="legal-page-title">
      <div class="container legal-hero-container">
        <p class="legal-eyebrow">Legal and support</p>
        <h1 id="legal-page-title">{{ page.title }}</h1>
        <p class="legal-intro">{{ page.intro }}</p>
        <span class="legal-updated">Last updated: {{ page.updated }}</span>
      </div>
    </section>

    <section class="legal-area">
      <div class="container legal-layout">
        <aside class="legal-summary" aria-label="Document summary">
          <strong>In this notice</strong>
          <ol>
            <li *ngFor="let section of page.sections">
              <a [href]="'#' + section.id">{{ section.title }}</a>
            </li>
          </ol>
        </aside>

        <article class="legal-content">
          <section *ngFor="let section of page.sections; let i = index" [id]="section.id">
            <span class="legal-number">{{ (i + 1) < 10 ? '0' + (i + 1) : (i + 1) }}</span>
            <h2>{{ section.title }}</h2>
            <div class="legal-body" [innerHTML]="section.bodyHtml"></div>
          </section>
        </article>
      </div>
    </section>
  </main>
</div>
